import React from 'react';
import Icon from 'components/AppIcon';

const ResourceNetwork = () => {
  const resourceCategories = [
    {
      title: 'Infrastructure d\'Hébergement',
      description: 'Ressources cloud et serveurs dédiés garantissant disponibilité maximale',
      icon: 'Database',
      features: [
        'Centres de données redondants multi-zones',
        'Bande passante illimitée et latence optimisée',
        'Sauvegardes automatiques quotidiennes',
        'Certification ISO 27001 sécurité'
      ],
      color: '#96121D'
    },
    {
      title: 'Associations Professionnelles',
      description: 'Réseau d\'organismes sectoriels et certifications reconnues',
      icon: 'Award',
      features: [
        'Membre actif chambres de commerce automobile',
        'Certifications qualité sectorielles',
        'Participation forums excellence industrie',
        'Accès formations continues spécialisées'
      ],
      color: '#9B8E57'
    },
    {
      title: 'Plateformes Technologiques',
      description: 'Écosystème d\'outils et APIs pour intégrations transparentes',
      icon: 'Code',
      features: [
        'APIs RESTful documentation complète',
        'SDKs pour intégrations rapides',
        'Webhooks temps réel notifications',
        'Support technique développeurs 24/7'
      ],
      color: '#96121D'
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div 
            className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold mb-6"
            style={{ backgroundColor: 'rgba(155, 142, 87, 0.1)', color: '#9B8E57' }}
          >
            <Icon name="Layers" size={16} className="mr-2" />
            Réseau de Ressources
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Infrastructure &{' '}
            <span style={{ color: '#9B8E57' }}>Écosystème</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un réseau complet de ressources techniques, professionnelles et institutionnelles 
            qui soutiennent notre engagement d'excellence.
          </p>
        </div>

        {/* Resource Categories */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {resourceCategories?.map((category, index) => (
            <div 
              key={index}
              className="group relative bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-current"
              style={{ '--hover-color': category?.color }}
            >
              {/* Icon Header */}
              <div className="mb-6">
                <div 
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-4"
                  style={{ backgroundColor: `${category?.color}20` }}
                >
                  <Icon 
                    name={category?.icon} 
                    size={32}
                    style={{ color: category?.color }}
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {category?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {category?.description}
                </p>
              </div>

              {/* Features List */}
              <ul className="space-y-3">
                {category?.features?.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <Icon 
                      name="CheckCircle2" 
                      size={20} 
                      className="mr-3 mt-0.5 flex-shrink-0"
                      style={{ color: category?.color }}
                    />
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Hover Border Effect */}
              <div 
                className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{ 
                  boxShadow: `0 0 0 2px ${category?.color}`,
                  borderRadius: '1rem'
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Partnership Inquiry CTA */}
        <div 
          className="relative rounded-3xl p-12 text-center overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #96121D 0%, #9B8E57 100%)' }}
        >
          <div className="relative z-10">
            <Icon name="Sparkles" size={48} className="mx-auto mb-6 text-white" />
            <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Rejoignez Notre Réseau d'Excellence
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Explorez les opportunités de partenariat stratégique et découvrez 
              comment nos ressources peuvent propulser votre activité.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-8 py-4 bg-white text-gray-900 rounded-xl font-semibold hover:bg-gray-100 transition-colors duration-300 shadow-lg">
                <span className="flex items-center justify-center">
                  <Icon name="Send" size={20} className="mr-2" />
                  Demande de Partenariat
                </span>
              </button>
              <button 
                className="px-8 py-4 rounded-xl font-semibold transition-all duration-300 border-2 border-white text-white hover:bg-white/10"
              >
                <span className="flex items-center justify-center">
                  <Icon name="BookOpen" size={20} className="mr-2" />
                  Documentation Ressources
                </span>
              </button>
            </div>
          </div>

          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <svg className="w-full h-full" viewBox="0 0 100 100">
              <pattern id="resourcePattern" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
                <circle cx="2" cy="2" r="1" fill="white" />
                <circle cx="7" cy="7" r="0.5" fill="white" />
              </pattern>
              <rect width="100%" height="100%" fill="url(#resourcePattern)" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourceNetwork;